/* eslint-disable no-prototype-builtins */
/* eslint-disable @typescript-eslint/no-explicit-any */

import IconMinus from '@assets/icons/minus.svg?react';
import {
 SortableContext,
 verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { Box, IconButton, Theme } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { DraggableField } from './DraggableField';
import { TransformedStructure } from './fieldsModalTypes';

interface FieldsModalCurrentProps {
 selectedFields: TransformedStructure[];
 removeSelectedField: (id: string) => void;
 removeAllSelectedFields: () => void;
}

const FieldsModalCurrent = (props: FieldsModalCurrentProps) => {
 const { selectedFields, removeSelectedField, removeAllSelectedFields } = props;
 const { t } = useTranslation();

 return (
  <Box
   sx={{
    borderRadius: '4px',
    border: (theme: Theme) => `1px solid ${theme.palette.kemek.lightestGray}`,
    flex: 1,
    minHeight: 0,
    mr: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
   }}
  >
   <Box
    sx={{
     flexShrink: 0,
     py: 1,
     px: '12px',
     display: 'flex',
     alignItems: 'center',
     justifyContent: 'space-between',
     borderBottom: (theme: Theme) =>
      `1px solid ${theme.palette.kemek.lightestGray}`,
     '.MuiButtonBase-root.MuiCheckbox-root': { p: '6px' },
    }}
   >
    <span>{t('fieldsModal.fieldsSelected')}</span>
    <IconButton
     sx={{ width: 24, height: 24, p: '4px' }}
     title={t('fieldsModal.removeAllFields')}
     aria-label={t('fieldsModal.removeAllFields')}
     onClick={removeAllSelectedFields}
    >
     <IconMinus />
    </IconButton>
   </Box>
   <Box
    sx={{
     flex: 1,
     minHeight: 0,
     overflowY: 'auto',
     p: '4px',
     display: 'flex',
     flexDirection: 'column',
     gap: 1,
    }}
   >
    <SortableContext
     items={selectedFields.map((field) => field?.Key)}
     strategy={verticalListSortingStrategy}
    >
     {selectedFields.map((field) => (
      <DraggableField
       key={field.Key}
       item={field}
       highlight={field.Translation}
       depth={0}
       removeSelectedField={removeSelectedField}
      />
     ))}
    </SortableContext>
    {selectedFields.length === 0 && (
     <Box
      color="text.secondary"
      sx={{
       p: 1,
       //    borderRadius: '4px',
       fontSize: 12,
       //    background: (theme: Theme) => theme.palette.kemek.bg2,
       //    p: 1,
      }}
     >
      {t('fieldsModal.dragFieldsHere')}
     </Box>
    )}
   </Box>
  </Box>
 );
};

export default FieldsModalCurrent;

